import { useEffect } from "react";
import Page from "../../finwell/pages/Page";
import ComplianceReportSectionAgentDetail from "../../components/Reports/complianceReport/ComplianceReportSectionAgentDetail";
import ComplianceReportSectionDetail from "../../components/Reports/complianceReport/ComplianceReportSectionDetail";
import CONFIG from "../../utils/config";

export const ComplianceReportAgentDetailPageMobile = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    let sendHeight = setInterval(() => {
      let obj = {
        method: "height",
        value: document.getElementById("root").scrollHeight + 120,
      };
      console.log("height: ", obj);
      window.parent.postMessage(obj, "*");
    }, 3000);

    return () => {
      clearInterval(sendHeight);
    };
  }, []);

  return (
    <div className="container pb-2rem">
      <ComplianceReportSectionAgentDetail isMobile={true} />
    </div>
  );
};

export default ComplianceReportAgentDetailPageMobile;
